import { getCurrentLocale, isDefaultLocale } from "./language-helpers";

const getBaseUrl = (currentLanguage = '') => {
  if (!currentLanguage) {
    currentLanguage = getCurrentLocale();
  }

  return isDefaultLocale(currentLanguage) ? '' : '/' + currentLanguage;
};

export default {
  generate(uri, params, locale) {
    let url = getBaseUrl(locale) + uri;
    if (typeof params === 'object' && Object.keys(params).length > 0) {
      url =
        url +
        '?' +
        Object.keys(params)
          .map(
            key =>
              encodeURIComponent(key) + '=' + encodeURIComponent(params[key]),
          )
          .join('&');
    }

    return url;
  },

  getMoneyServiceIconByName(iconName) {
    return `${PAYBIS_ICONS_BASE_URL}/default/money-services/${iconName}.svg`;
  },

  //TODO: clean up, if not used anymore
  getMoneyServiceIconPath(filename) {
    return `/images/money-services/${filename}`;
  },
};
